// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27GRx","col":"styles_col__3G3Qr"};